(ns motorsaif.web.admin.edit-business
  (:require
   [motorsaif.web.forms.business :as business-form]
   [motorsaif.data-utils :as data-utils :refer [assoc-if-val]]
   [clojure.string :as str]
   [goog.string :refer [format]]
   [motorsaif.web.components :as c]
   [motorsaif.validation :as validation]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

(defn main []
  (let [{:keys [id]} @(subscribe [:route/parameters])
        business (data-utils/wrap-results @(subscribe [:admin-data :businesses id]))
        ;; {:business/keys [name description]} business
        {:business/keys [misc location]} business
        init-data {:business (-> business
                                 ;; (dissoc :roles)
                                 (assoc :business/location
                                        (:db/id location)))}
        form-key :admin-edit-business
        on-submit (fn [{:keys [new-data all-data]}]
                    (let [new-media (vec (remove nil? (get-in new-data [:business :business/media])))
                          new-data (-> new-data
                                       (cond-> (seq new-media)
                                         (assoc-in [:business :business/media] new-media)))

                          new-misc (get-in all-data [:business :business/misc])

                          data (-> new-data
                                   (assoc-in [:business :db/id] id)
                                   (assoc-if-val [:business :business/misc] new-misc))

                          req {:type :PUT
                               :url     "/api/businesses"
                               :params {:data data}
                               :id :new-request
                               :handler
                               (fn [{:keys [success ex-message] :as res}]
                                 (if success
                                   (do
                                     (rf/dispatch [:toast {:type "success"
                                                           :message "Business updated. Reloading..."}])
                                     (js/setTimeout (fn []
                                                      (js/window.location.reload)) 800))
                                   (rf/dispatch
                                    [:toast {:type "error"
                                             :message (format "Failed to save: %s " ex-message)}])))
                               :error-handler (fn [res])}]
                      (rf/dispatch [:do-ajax req])))

        make-form-args
        {:schema validation/edit-business
         :change-watch #(dispatch [:reset-form form-key %])
         :on-submit {:valid on-submit
                     :invalid
                     (fn [error]
                       (let [error-titles ((:error-titles-fn error) :edit-business)]
                         (rf/dispatch [:toast {:type "error"
                                               :timeout 5000
                                               :title "Failed to save"
                                               :message (str/join ", " error-titles)}])))}
         :init-data init-data}]
    (fn []
      [:div
       [c/header-with-back
        "Edit Business"]
       [:div.container
        [business-form/form
         {:form-key form-key
          :make-form-args make-form-args}]]])))

(defn root []
  (let [{:keys [id]} @(subscribe [:route/parameters])
        business (data-utils/wrap-results @(subscribe [:admin-data :businesses id]))]
    (when business
      [main])))
